import React from 'react'

// types
import { InputLabelProps } from './types'

// styles
import * as SC from './InputLabelStyles'

const InputLabel = (props: InputLabelProps) => {
	const { children, required, htmlFor, id, screenReaderOnly } = props

	return (
		<SC.InputLabel id={id} htmlFor={htmlFor} $required={required} $screenReaderOnly={screenReaderOnly}>
			{children}
		</SC.InputLabel>
	)
}

export default InputLabel
